import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
export default [{
  path: '/member/home',
  name: ROUTE_NAME.MEMBER,
  meta: {
    title: '等级',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "lucky" */
      '@/pages/member/home.vue')
    };
  }
}];